<template>
  <div id="app">
    <header>
      <div id="nav">
        <b-navbar toggleable="lg" type="light" variant="mdh">
          <b-navbar-brand href="#">
            <img src="./assets/logo-reverse.png" style="height:38px;" alt="Minnesota Department of Health Logo"/>
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
            
                <b-nav-item href="/home">Your Buckets</b-nav-item>

                <b-nav-item href="/bucketList">List of Current Buckets</b-nav-item>

                <b-nav-item-dropdown text="Admin"
                     v-if="$keycloak.authenticated && ($keycloak.hasResourceRole('admin') || $keycloak.hasResourceRole('bucket-admin'))">
                    <b-dropdown-item href="/bucket">Manage Buckets</b-dropdown-item>
                    <b-dropdown-item href="/searchUser" v-if="$keycloak.hasResourceRole('admin')">Search User Permissions</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown text="Report"
                                     v-if="$keycloak.authenticated && $keycloak.hasResourceRole('admin')">
                    <b-dropdown-item href="/eventReport">Event</b-dropdown-item>
                    <b-dropdown-item href="/errorReport">Error</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item @click="$keycloak.logoutFn" v-if="$keycloak.authenticated">Log out</b-nav-item>
                <b-nav-item @click="login" v-if="!$keycloak.authenticated">Log in</b-nav-item>
            
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </header>

     <main id="main-content">
      <b-container fluid>
              <router-view/>
      </b-container>
    </main>
  
    
  </div>
</template>

<script>

export default {
  name: 'app',
  data: () => ({
  }),
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

#app {
  font-family: 'Roboto', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

h1 {
  font-size: 24px;
  font-weight: 600;
}

h2 {
  font-size: 24px;
  font-weight: 600;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.bg-mdh {
  background-color: rgb(0, 56, 101);
}

#nav {
  padding-bottom: 30px;
}

#nav a {
  font-weight: normal;
  color: white;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#nav  a.dropdown-item {
  color: black !important;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}

</style>